export const CategoriesInput = [
    {name:'Ring',value:'Ring',id:27},{name : 'Skewers',value:'Skewers',id:7},{name : 'Pouch',value:'Pouch',id:26},{name : 'Platter',value:'Platter',id:28},{name : 'Nobashi',value:'Nobashi',id:39}
]